import { pick, values } from 'ramda'
import { useMemo } from 'react'

import { useSaleTypesData } from './useSaleTypesData'


type Options = {
  sort?: 'byTitle'
  saleTypesIds?: Array<string>
}

export const useSaleTypesAsArray = (options: Options = {} as Options) => {
  const { saleTypesState, loading } = useSaleTypesData()
  const { sort, saleTypesIds } = options

  const saleTypes = useMemo(() => {
    const items = values(saleTypesIds ? pick(saleTypesIds, saleTypesState) : saleTypesState)
    if (sort === 'byTitle') {
      return items.sort((a, b) => a.title.localeCompare(b.title))
    }
    return items
  }, [saleTypesState, sort, saleTypesIds])

  return {
    saleTypes,
    loading,
  }
}
